import {
  Button,
  Grid,
  IconButton,
  styled,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import MWCaption from "../../components/MWCaption";

import DeleteIcon from "@mui/icons-material/Delete";
import SummarizeIcon from "@mui/icons-material/Summarize";
import {Box} from "@mui/system";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import MWInputFile from "../../components/MWInputFile";
import {useConvertBase64} from "../../hooks/useConvertBase64";
import {EQDocument} from "../../models/serverModels/workOrder/EQDocument";
import ko from "date-fns/locale/ko";

const CategoryFormContainer = styled(Grid)(({theme}) => ({
  justifyContent: "center",
  alignItems: "center",
  marginTop: "16px",

  backgroundColor: theme.palette.gray.main,
}));

const CategoryFormContent = styled(Grid)(({theme}) => ({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  margin: "32px 0",

  padding: "24px",
  backgroundColor: theme.palette.gray.dark,

  border: `1px solid ${theme.palette.background.paper}`,
  borderRadius: "16px",
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& label": {
    fontWeight: 600,
    paddingRight: "8px",
  },
}));

const DocumentList = styled(Box)(({theme}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& label": {
    flexBasis: "30%",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));
type DocumentProps = {
  subText: string;
  captionColor?: string;
};

const DocumentForm = ({subText, captionColor}: DocumentProps) => {
  const {convertChangeHandler, image} = useConvertBase64();

  const isMobile = useMediaQuery("(max-width: 900px)");

  const methods = useFormContext<EQDocument>();

  const {
    setValue,
    control,
    watch,
    formState: {errors},
  } = methods;

  return (
    <React.Fragment>
      <MWCaption title={subText} color={captionColor} icon={<SummarizeIcon />} />
      <CategoryFormContainer container>
        <CategoryFormContent
          item
          xs={12}
          sm={12}
          md={6}
          xl={4}
          sx={{padding: {xs: "16px 4px", sm: "16px 8px", md: "24px"}}}
        >
          <Controller
            name="description"
            control={control}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="name">파일 설명 : </label>
                <TextField
                  {...field}
                  id="description"
                  size="small"
                  placeholder="파일 설명"
                  margin="dense"
                  autoFocus
                  helperText={error?.message}
                  sx={{width: "100%"}}
                />
              </DocumentList>
            )}
          />
          <Controller
            name="modifyDate"
            control={control}
            render={({field, ...props}) => (
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
                <DocumentList>
                  <label htmlFor="modifyDate">개정일 : </label>
                  <DatePicker
                    inputFormat={"yyyy년 MM월 dd일"}
                    value={field.value}
                    onChange={(date) => {
                      if (!date) return field.onChange(null);

                      const d = new Date(date); // string 가능 → 자동 파싱됨

                      const fixed = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 9, 0, 0);

                      field.onChange(fixed);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        id="modifyDate"
                        size="small"
                        margin="dense"
                        sx={{width: "100%", marginBottom: "16px"}}
                      />
                    )}
                  />
                </DocumentList>
              </LocalizationProvider>
            )}
          />
          {isMobile ? (
            <MWInputFile file="base64" fileName="fileName" buttonLabel="파일선택" />
          ) : (
            <Controller
              name="base64"
              control={control}
              render={({field: {onChange, name, value}, fieldState: {error}}) => (
                <>
                  <Grid
                    container
                    sx={{
                      marginTop: "12px",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button variant="outlined" component="label" size="small" sx={{height: "30px"}}>
                      파일 선택
                      <TextField
                        sx={{display: "none"}}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          convertChangeHandler(event, setValue, name, "fileName")
                        }
                        type="file"
                        id="base64"
                        size="small"
                        hidden
                      />
                    </Button>
                    <Typography align="left" sx={{marginLeft: "8px", width: "60%"}}>
                      {watch("fileName")}
                    </Typography>
                    <IconButton
                      aria-label="delete"
                      color="secondary"
                      onClick={() => {
                        setValue("base64", "");
                        setValue("fileName", "");
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                  {errors.base64 && (
                    <Typography sx={{fontSize: "12px", color: "red"}}>
                      {errors.base64.message}
                    </Typography>
                  )}
                </>
              )}
            />
          )}
        </CategoryFormContent>
      </CategoryFormContainer>
    </React.Fragment>
  );
};

export default DocumentForm;
